import FieldTitle from './form/RenderTitle';
import FieldSubmit from './form/RenderSubmit';
import Tabs from './Tabs/Render';
import FieldName from './name/Render';
import FieldPhone from './phone/Render';
import FieldMail from './mail/Render';
import FieldTextarea from './textarea/Render';
import FieldRadio from './radio/Render';
import FieldString from './textfield/Render';
import FieldNumber from './number/Render';
import FieldList from './list/Render';
import FieldCheckBox from './checkbox/Render';
import FieldCountry from './country/Render';
import FieldDate from './date/Render';
import FieldDateTime from './datetime/Render';
import FieldTime from './time/Render';
import FieldPromo from './promo/Render';
import FieldImage from './image/Render';
import Directions from './directions/Render';

export const fields = [
	{ name: `directions`, component: Directions },
	{ name: `tabs`, 		component: Tabs },
	{ name: `title`, 		component: FieldTitle },
	{ name: `submit`, 	component: FieldSubmit },
	{ name: `name`, 		component: FieldName },
	{ name: `phone`, 		component: FieldPhone },
	{ name: `email`, 		component: FieldMail },
	{ name: `textarea`, component: FieldTextarea },
	{ name: `textfield`,component: FieldString },
	{ name: `number`, 	component: FieldNumber },
	{ name: `list`, 		component: FieldList },
	{ name: `image`, 		component: FieldImage },
	{ name: `radio`, 		component: FieldRadio },
	{ name: `checkbox`, component: FieldCheckBox },
	{ name: `country`, 	component: FieldCountry },
	{ name: `date`, 		component: FieldDate },
	{ name: `datetime`, component: FieldDateTime },
	{ name: 'time', 		component: FieldTime },
	{ name: 'promo', 		component: FieldPromo
	}
]

export default function getFieldConfig(type: string){
	const { component }: any = [...fields].filter(a=> type === a.name ).shift()
	return component;
}